import { useState } from 'react';
import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { actions } from 'store';
import { ModalButtonWithForm } from 'components/common';
import { ProductUserCustomAttributesForm } from '.';

import type { CustomAttributesFormType } from './ProductUserCustomAttributesForm';

interface Props {
  addAttributeSuccessText?: string;
  addAttributeText?: string;
  hideAnalyticsControl: boolean;
  numberOfAttributes: number;
  updateData: () => Promise<void>;
  urlState: string;
}

const ProductUserCustomAttributesAdd = ({
  addAttributeSuccessText,
  addAttributeText,
  hideAnalyticsControl,
  numberOfAttributes,
  updateData,
  urlState
}: Props) => {
  const { dispatch } = useDispatch();

  const { messages } = useReduxState();

  const [formIsVisible, setFormIsVisible] = useState(false);

  const handleSubmit = async (values: CustomAttributesFormType) => {
    await api.post(`/admin/product-user-custom-attributes/${urlState}`, {
      ...initialValues,
      ...values,
      position: numberOfAttributes + 1
    });
    dispatch(
      actions.addNotice({
        text: addAttributeSuccessText || messages.attributesAddSuccess,
        type: 'success'
      })
    );
    await updateData();
  };

  const initialValues = {
    includeInAnalytics: false,
    isRequired: false,
    max: 10,
    min: 0,
    options: [],
    title: '',
    titleTranslations: '{}',
    type: 'String'
  } as CustomAttributesFormType;

  return (
    <ModalButtonWithForm
      buttonCategory="success"
      buttonIcon="plus"
      buttonSize="header"
      buttonText={addAttributeText || messages.attributesAdd}
      initialValues={initialValues}
      modalActionText={messages.commonAdd}
      modalTitle={addAttributeText || messages.attributesAdd}
      modalWidth="medium"
      onHide={() => setFormIsVisible(false)}
      onModalVisible={() => setFormIsVisible(true)}
      onSubmit={handleSubmit}
    >
      {() =>
        formIsVisible ? (
          <ProductUserCustomAttributesForm
            hideAnalyticsControl={hideAnalyticsControl}
            urlState={urlState}
          />
        ) : null
      }
    </ModalButtonWithForm>
  );
};

export default ProductUserCustomAttributesAdd;
